import { render, staticRenderFns } from "./goal-card.vue?vue&type=template&id=fc473874&"
import script from "./goal-card.vue?vue&type=script&lang=ts&"
export * from "./goal-card.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports